// Reverse propagation link of card when user click on card (not if class have no-card-link)
(function (document, window) {
    document.addEventListener("DOMContentLoaded", function () {
        document.addEventListener('click', function reversePropagationLink(e) {
            const card = e.target.closest('.card');
            if (!card || card.classList.contains('no-card-link')) return;
            if (!card.querySelector('a[href]')) return;
            const link = card.querySelector('a[href]');
            const href = link.getAttribute('href');
            if (link.getAttribute('target') === '_blank') {
                window.open(href, '_blank');
            } else {
                window.location.href = href;
            }
        });
    })
})(document, window);